/// <reference types="@lib/types" />
export function isOptionSetDisabled(optionSet) {
    return optionSet.disabled === true || optionSet._internal?.disabled === true;
}
export function isOptionSetAvailableForOrdering(optionSet) {
    return !isOptionSetDisabled(optionSet);
}
export function buildOptionSetAttachUpdates(menus, optionSetIds, dishIds) {
    const targetDishIds = new Set(dishIds);
    const selectedOptionSetIds = optionSetIds.filter(Boolean);
    const updates = [];
    for (const menu of menus || []) {
        for (const category of menu.categories || []) {
            for (const dish of category.dishes || []) {
                if (!targetDishIds.has(dish._id))
                    continue;
                const currentOptionSets = [...(dish.option_sets || [])];
                const nextOptionSets = [...currentOptionSets];
                for (const optionSetId of selectedOptionSetIds) {
                    if (!nextOptionSets.includes(optionSetId))
                        nextOptionSets.push(optionSetId);
                }
                if (nextOptionSets.length === currentOptionSets.length)
                    continue;
                updates.push({
                    menu_id: menu._id,
                    category_id: category._id,
                    id: dish._id,
                    option_sets: nextOptionSets,
                });
            }
        }
    }
    return updates;
}
export function getDishIdsWithOptionSets(menus, optionSetIds) {
    const selectedOptionSetIds = new Set(optionSetIds.filter(Boolean));
    const dishIds = [];
    for (const menu of menus || []) {
        for (const category of menu.categories || []) {
            for (const dish of category.dishes || []) {
                if ((dish.option_sets || []).some((id) => selectedOptionSetIds.has(id))) {
                    dishIds.push(dish._id);
                }
            }
        }
    }
    return dishIds;
}
export function buildOptionSetDetachUpdates(menus, optionSetIds, dishIds) {
    const targetDishIds = new Set(dishIds);
    const selectedOptionSetIds = new Set(optionSetIds);
    const updates = [];
    for (const menu of menus || []) {
        for (const category of menu.categories || []) {
            for (const dish of category.dishes || []) {
                if (!targetDishIds.has(dish._id))
                    continue;
                const currentOptionSets = [...(dish.option_sets || [])];
                const nextOptionSets = currentOptionSets.filter((id) => !selectedOptionSetIds.has(id));
                if (nextOptionSets.length === currentOptionSets.length)
                    continue;
                updates.push({
                    menu_id: menu._id,
                    category_id: category._id,
                    id: dish._id,
                    option_sets: nextOptionSets,
                });
            }
        }
    }
    return updates;
}
export function buildOptionSetDetachAllUpdates(menus, optionSetIds) {
    return buildOptionSetDetachUpdates(menus, optionSetIds, getDishIdsWithOptionSets(menus, optionSetIds));
}
export function buildModifierAttachUpdates(menus, modifierIds, itemIds) {
    const targetItemIds = new Set(itemIds);
    const selectedModifierIds = modifierIds.filter(Boolean);
    const updates = [];
    for (const menu of menus || []) {
        for (const item of menu.items || []) {
            if (!targetItemIds.has(item.id))
                continue;
            const currentModifiers = [...(item.modifiers || [])];
            const nextModifiers = [...currentModifiers];
            for (const modifierId of selectedModifierIds) {
                if (!nextModifiers.includes(modifierId))
                    nextModifiers.push(modifierId);
            }
            if (nextModifiers.length === currentModifiers.length)
                continue;
            updates.push({
                menu_id: item.menu_id,
                category_id: item.category_id,
                id: item.id,
                modifiers: nextModifiers,
            });
        }
    }
    return updates;
}
export function getItemIdsWithModifiers(menus, modifierIds) {
    const selectedModifierIds = new Set(modifierIds.filter(Boolean));
    const itemIds = [];
    for (const menu of menus || []) {
        for (const item of menu.items || []) {
            if ((item.modifiers || []).some((id) => selectedModifierIds.has(id))) {
                itemIds.push(item.id);
            }
        }
    }
    return itemIds;
}
export function buildModifierDetachUpdates(menus, modifierIds, itemIds) {
    const targetItemIds = new Set(itemIds);
    const selectedModifierIds = new Set(modifierIds);
    const updates = [];
    for (const menu of menus || []) {
        for (const item of menu.items || []) {
            if (!targetItemIds.has(item.id))
                continue;
            const currentModifiers = [...(item.modifiers || [])];
            const nextModifiers = currentModifiers.filter((id) => !selectedModifierIds.has(id));
            if (nextModifiers.length === currentModifiers.length)
                continue;
            updates.push({
                menu_id: item.menu_id,
                category_id: item.category_id,
                id: item.id,
                modifiers: nextModifiers,
            });
        }
    }
    return updates;
}
export function buildModifierDetachAllUpdates(menus, modifierIds) {
    return buildModifierDetachUpdates(menus, modifierIds, getItemIdsWithModifiers(menus, modifierIds));
}
//# sourceMappingURL=option-sets.js.map